import React from "react";
import { Button } from "../ui/Button";
import { Input } from "../ui/Input";
import { ColumnSelector } from "./ColumnSelector";
import { type VisibilityState } from "@tanstack/react-table";

interface TableFilterProps {
  globalFilter: string;
  onGlobalFilterChange: (value: string) => void;
  onClearSearch: () => void;
  columnHeaders?: string[];
  columnVisibility?: VisibilityState;
  onColumnVisibilityChange?: (columnId: string, isVisible: boolean) => void;
}

export const TableFilter: React.FC<TableFilterProps> = ({
  globalFilter,
  onGlobalFilterChange,
  onClearSearch,
  columnHeaders = [],
  columnVisibility = {},
  onColumnVisibilityChange,
}) => {
  return (
    <div className="p-6">
      <div className="flex flex-wrap items-center justify-end gap-4">
        <div className="relative">
          <Input
            type="text"
            placeholder="Search Claims..."
            value={globalFilter ?? ""}
            onChange={(event) => onGlobalFilterChange(String(event.target.value))}
            className="w-44 sm:w-64"
          />
        </div>
        {globalFilter && (
          <Button
            variant="outline"
            onClick={onClearSearch}
            className="portrait:px-2 portrait:text-sm"
          >
            Clear Search
          </Button>
        )}
        {columnHeaders.length > 0 && onColumnVisibilityChange && (
          <ColumnSelector
            columns={columnHeaders}
            visibleColumns={columnVisibility}
            onVisibilityChange={onColumnVisibilityChange}
          />
        )}
      </div>
    </div>
  );
};
